import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers';
import { useEffect, useState } from 'react';

FilterDatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export function FilterDatePicker(props) {
  const { value, onChange, ...rest } = props;
  const [selectedDate, setSelectedDate] = useState(value);

  useEffect(() => {
    setSelectedDate(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        data-testid="filter-date-picker"
        value={dayjs(selectedDate)}
        views={['year', 'month', 'day']}
        slotProps={{
          textField: {
            variant: 'filled',
            inputProps: { sx: { paddingTop: '18px' } },
            sx: {
              mt: 1,
              mb: 2,
              width: '100%',
            },
          },
        }}
        onChange={onDateChange}
        {...rest}
      />
    </LocalizationProvider>
  );

  function onDateChange(event) {
    onChange(event.$d);
  }
}
